module.exports = __webpack_public_path__ + "img/vicon4.fe7d33a3.png";